import React from 'react';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { DisplaySizes } from '@newcore/ui/enums/typography-display-sizes';
import { Skeleton } from '@newcore/ui/skeleton';
import { Display, Text } from '@newcore/ui/typography';

interface PageHeaderProps {
  title: string;
  description?: string;
  descriptionLoading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const PageHeader = React.memo(
  ({
    title,
    description,
    descriptionLoading,
    children,
    className,
  }: PageHeaderProps) => {
    return (
      <header className={cn('flex w-full items-start gap-6', className)}>
        <div className='flex flex-1 flex-col gap-0.5'>
          <Display
            as='h1'
            size={DisplaySizes.XS}
            weight={FontWeights.SEMIBOLD}
            className='text-primary'
          >
            {title}
          </Display>
          {(descriptionLoading || description) && (
            <Text as='p' className='max-w-150 text-secondary'>
              {descriptionLoading ? (
                <span className={cn('inline-grid', !description && 'w-20')}>
                  {description && (
                    <span
                      className='invisible col-start-1 row-start-1 select-none'
                      aria-hidden
                    >
                      {description}
                    </span>
                  )}
                  <Skeleton
                    className='col-start-1 row-start-1 h-[1em] self-center rounded-sm'
                    aria-hidden
                  />
                </span>
              ) : (
                description
              )}
            </Text>
          )}
        </div>
        {children && <div className='flex items-center gap-2'>{children}</div>}
      </header>
    );
  }
);

PageHeader.displayName = 'PageHeader';
